import { CanActivateFn, Router } from '@angular/router';
import { inject } from '@angular/core';
import { APP_ROUTES } from '../../app.routes.model';
import { StorageService } from '../services/storage/storage.service';

export const hdAuthGuard: CanActivateFn = () => {
  const router = inject(Router);
  const isHd = inject(StorageService).isHdUser$$();

  if (isHd) {
    return true;
  }

  // Not an HD user go to home page of organization
  return router.navigate([APP_ROUTES.organizations.myOrganization]);
};
